<template>

</template>

<script>
import CONST from "@/utils/Constants";
import GAMixins from "../mixins/GAMixins";


export default {
  name: "PDPComponent",
  data() {
    return {
      product: {},
      collectionMap: {},
      categoryPathResolverEn: "",
      fastOrderResponse: null
    }
  },
  mixins: [
    GAMixins
  ],
  props: [
    'collectionMap',
    'categoryPath',
  ],
  methods: {
    printAddToCartMyAccount(entries, list) {
      ACC.log.group("printAddToCartMyAccount")
      ACC.log.info({'entries': entries}, {'list': list})
      const entry = {
        event: 'add_to_cart',
        ecommerce: {
          currency: ACC.config.user.currency.isocode,
          value: entries.reduce((accumulator, entry) => {
            return accumulator + entry.totalPrice.value;
          }, 0),
          commercial_organization: CONST.DIVISION.COMMERCIAL_ORGANIZATION[ACC.config.flagVistaDivision][ACC.config.society],
          items: this.getProductEntries(entries, list)
        }
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printAddToCart(entry, quantity, dimension, collectionMap) {
      ACC.log.group("printAddToCart")
      ACC.log.info({'entry': entry}, {'quantity': quantity}, {'dimension': dimension}, {'collectionMap': collectionMap})
      const gaEntry = {
        event: 'add_to_cart',
        ecommerce: {
          currency: ACC.config.user.currency.isocode,
          value: entry.totalPrice.value,
          commercial_organization: CONST.DIVISION.COMMERCIAL_ORGANIZATION[ACC.config.flagVistaDivision][ACC.config.society],
          items: [
            this.buildProductGAObject(entry.product, entry.totalPrice.value, entry.flagVista, Number(quantity), this.getDimension(dimension), null, null, collectionMap, entry)
          ]
        }
      }
      this.pushEvent(gaEntry);
      console.groupEnd();
    },
    printProductDetailView(quantity, dimension) {
      ACC.log.group("printProductDetailView")
      ACC.log.info({'quantity': quantity}, {'dimension': dimension})
      const entry = {
        event: 'view_item',
        ecommerce: {
          commercial_organization: CONST.DIVISION.COMMERCIAL_ORGANIZATION[ACC.config.flagVistaDivision][ACC.config.society],
          items: [
            this.buildProductGAObject3(this.product, isNaN(dimension) ? 0 : this.getPrice(this.product.price) * quantity * this.getDimension(dimension), ACC.config.flagVistaDivision, null, null, null, null, this.collectionMap)
          ]
        }
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printAddToWishlist(quantity, dimension) {
      ACC.log.group("printAddToWishlist")
      ACC.log.info({'quantity': quantity}, {'dimension': dimension})

      const entry = {
        event: 'add_to_wishlist',
        ecommerce: {
          commercial_organization: CONST.DIVISION.COMMERCIAL_ORGANIZATION[ACC.config.flagVistaDivision][ACC.config.society],
          currency: ACC.config.user.currency.isocode,
          value: this.getGAPrice(this.product.price, Number(quantity), this.getDimension(dimension)),
          items: [
            this.buildProductGAObject4(this.product, isNaN(dimension) ? 0 : this.getPrice(this.product.price) * Number(quantity) * this.getDimension(dimension), ACC.config.flagVistaDivision, Number(quantity), dimension, null, null, this.collectionMap)
          ]
        }
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printGoToProduct(id, quantity, dimension) {
      ACC.log.group("printGoToProduct")
      ACC.log.info({'id': id}, {'quantity': quantity}, {'dimension': dimension})
      const entry = {
        event: 'go_to_product',
        product_code: id,
        product_selected_quantity: Number(quantity),
        product_selected_dimension: this.getDimension(dimension)
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printCheckAvailability(id, quantity, dimension, availability, references, matricola) {
      ACC.log.group("printCheckAvailability")
      ACC.log.info({'id': id}, {'quantity': quantity}, {'dimension': dimension}, {'availability': availability}, {'references': references}, {'matricola': matricola})
      const entry = {
        event: 'check_availability',
        product_code: id,
        product_selected_quantity: Number(quantity),
        product_selected_dimension: this.getDimension(dimension),
        product_availability_result: availability === "true",
        use_piece_number: !!matricola,
        use_references: !!references
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printBackInStock(id, quantity, dimension, availability, references, matricola) {
      ACC.log.group("printBackInStock")
      ACC.log.info({'id': id}, {'quantity': quantity}, {'dimension': dimension}, {'availability': availability}, {'references': references}, {'matricola': matricola})
      const entry = {
        event: 'back_in_stock_notify',
        product_code: id,
        product_selected_quantity: Number(quantity),
        product_selected_dimension: this.getDimension(dimension),
        product_availability_result: availability === "true",
        use_piece_number: !!matricola,
        use_references: !!references
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printSimilarProducts(id, quantity, dimension, availability, references, matricola) {
      ACC.log.group("printSimilarProducts")
      ACC.log.info({'id': id}, {'quantity': quantity}, {'dimension': dimension}, {'availability': availability}, {'references': references}, {'matricola': matricola})
      const entry = {
        event: 'find_similar_articles',
        product_code: id,
        product_selected_quantity: Number(quantity),
        product_selected_dimension: this.getDimension(dimension),
        product_availability_result: availability === "true",
        use_piece_number: !!matricola,
        use_references: !!references
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
    printDownloadEvent(type) {
      ACC.log.group("printDownloadEvent")
      ACC.log.group({'type': type})
      const entry = {
        event: 'download',
        download_type: type,
        product_name: this.product && this.product.nameEn,
        product_code: this.product && this.product.sku,
        // product_brand: this.getBrand(this.collectionMap.collection, ACC.config.flagVistaDivision),
        // product_category: this.getCategory(null, this.collectionMap),
        product_collection: this.collectionMap && this.collectionMap.collection,
        product_service: this.collectionMap && this.collectionMap.service,
        product_season: this.collectionMap && this.collectionMap.season,
        product_cod1: this.product && this.product.cod1,
        product_cod2: this.product && this.product.cod2,
        product_cod3: this.product && this.product.cod3,
        product_cod4: this.product && this.product.cod4,
        product_cod5: this.product && this.product.cod5
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
  },

  created() {
    //INIT PRODUCT DATA
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.INIT, ({product, collectionMap, quantity, dimension}) => {
      this.product = product;
      this.collectionMap = collectionMap;

      this.printProductDetailView(quantity, dimension);
    });

    // BIND ADD TO CART EVENT
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.ADD_TO_CART_SUCCESS, ({success, quantity, dimension, collectionMap, entry}) => {
      this.success = success;
      this.quantity = quantity;
      this.causalityDescription = dimension;
      this.collectionMap = collectionMap;
      this.printAddToCart(entry, quantity, dimension, collectionMap);
    });

    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.ACCOUNT.REPEAT_ORDER, ({entries}) => {
      this.printAddToCartMyAccount(entries, "repeat_order_multi");
    });

    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.ACCOUNT.REPEAT_ENTRY, ({entries}) => {
      this.printAddToCartMyAccount(entries, "repeat_order_single");
    });

    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.FAST_ORDER.ADD_TO_CART_FAST_ORDER, ({entry, quantity, dimension, collectionMap}) => {
      this.collectionMap = collectionMap;
      this.printAddToCart(entry, quantity, dimension, collectionMap);
    });


    // BIND ADD TO WISHLIST
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.ADD_TO_WISHLIST, ({quantity, dimension}) => {
      this.printAddToWishlist(quantity, dimension);
    });

    // BIND ADD GO TO PRODUCT FAST ORDER
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.FAST_ORDER.GO_TO_PRODUCT, ({code, quantity, dimension}) => {
      this.printGoToProduct(code, quantity, dimension);
    });

    // BIND PRODUCT AVAILABILITY FAST ORDER
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.FAST_ORDER.CHECK_AVAILABILITY, ({id, quantity, dimension, availability, references, matricola, response}) => {
      ACC.log.info("CHECK_AVAILABILITY response", response);
      this.fastOrderResponse = response;
      this.fastOrderResponse.references = references
      this.fastOrderResponse.matricola = matricola
      this.fastOrderResponse.quantity = quantity
      this.fastOrderResponse.dimension = dimension
      this.printCheckAvailability(id, quantity, dimension, availability, references, matricola);
    });

    // BIND PRODUCT BACK IN STOCK FAST ORDER
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.FAST_ORDER.BACK_IN_STOCK, () => {
      this.printBackInStock(this.fastOrderResponse.productData.sku, this.fastOrderResponse.quantity, this.fastOrderResponse.dimension, this.fastOrderResponse.availability, this.fastOrderResponse.references, this.fastOrderResponse.matricola);
    });

    // BIND FIND SIMILAR PRODUCTS FAST ORDER
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.FAST_ORDER.SIMILAR_PRODUCTS, () => {
      this.printSimilarProducts(this.fastOrderResponse.productData.sku, this.fastOrderResponse.quantity, this.fastOrderResponse.dimension, this.fastOrderResponse.availability, this.fastOrderResponse.references, this.fastOrderResponse.matricola);
    });

    // BIND . DOWNLOAD HD IMAGE
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.DOWNLOAD_HD_IMAGE, () => {
      this.printDownloadEvent("hi-res");
    });

    // BIND DOWNLOAD TECH SHEET
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.DOWNLOAD_TECH_SHEET, () => {
      this.printDownloadEvent("tech_sheet");
    });

    // BIND DOWNLOAD INVOICE
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.DOWNLOAD_INVOICE, () => {
      this.printDownloadEvent("invoice");
    });

    // BIND DOWNLOAD DDT
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.DOWNLOAD_DDT, () => {
      this.printDownloadEvent("ddt");
    });

    // BIND DOWNLOAD DOCUEMNT
    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.PDP.DOWNLOAD_DOCUMENT, () => {
      this.printDownloadEvent("letter");
    });
  }
}


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/components/PDPComponent.vue